export const immutable = ['createdAt', 'updatedAt']
